export default __webpack_public_path__ + "d0629e840c23c91756767e4586ed0ff5.png";